/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_ReferralInputs */

const en_clients_field_referral = /** @type {(inputs: Clients_Field_ReferralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referral`)
};

const pt_br2_clients_field_referral = /** @type {(inputs: Clients_Field_ReferralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indicação`)
};

/**
* | output |
* | --- |
* | "Referral" |
*
* @param {Clients_Field_ReferralInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_referral = /** @type {((inputs?: Clients_Field_ReferralInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_ReferralInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_referral(inputs)
	return pt_br2_clients_field_referral(inputs)
});